//-- Copyright (c) 2021 TMT Insights Group, LLC
import { OrderPlacementConfig } from '@/__configs/config_types';

const orderPlacementConfig: OrderPlacementConfig = {
  entityTypes: [],
  // the custom fields that are displayed in steps 1 and 3
  addlFields: {
    orderDetails: {
      po_number: {
        label: 'Order Number',
        id: 'po_number'
      },
      billable_customer: {
        label: 'Client Name',
        id: 'billable_customer'
      }
    }
  }
  // the title display box under the title search on step 2 in both flows
  // viewingTitleHeader: (title: TitleEntity) => {},

  // the title search result item
  // titleSearchResult: (result: TitleEntity) => {},

  // advanced order step 2, the header of a grouped output job/version
  // outputHeader: (group: any, outputVersionObj: TitleEntity, profileEditType: string) => {},

  // the dropdown option for the version picker, used in order placement and title ui
  // versionDropdownOption: (option: TitleEntity) => {},

  // the selected option for the version picker, used in order placement and title ui
  // versionOptionLabel: (option: TitleEntity) => {},

  // the title of the pending files selections when grouped by version (files from 2 or more versions selected)
  // fileSelectionTitle: (version: TitleEntity) => {},

  // on simple flow step 2, the episode can be expanded to show more info about each version
  // expandedVersionRows: (versions: TitleEntity[]) => {},

  // the tooltip that's displayed when hovering over a version chip -- step 2 of simple flow
  // versionChipTooltip: (version: TitleEntity) => {},

  // parseVersionsFn: (versions: TitleEntity[]) => {},

  // parseFilesFn: (files: InventoryFile[]) => {},

  // parseTitlesFn: (titleResponse: TitleResponse) => {},

  // getLineageMetaTitle: (title: TitleEntity | {} = {}) => {},

  // bulkOrderJobDisplay: (job: OrderJob, title: any) => {
  //   return (
  //     <Grid container alignItems="center">
  //       <Grid item sm={1}>
  //         <strong>{job.hid}</strong>
  //       </Grid>
  //       <Grid item sm={2}>
  //         <JobTypeLabel type={job.job_type} />
  //       </Grid>
  //       <Grid item sm={3}>
  //         <Typography variant="body1" style={{ fontWeight: 'bold' }}>
  //           {job.title.lineage_meta?.series_name}
  //         </Typography>
  //         <Typography variant="caption" sx={{ opacity: 0.7 }}>
  //           {title}
  //         </Typography>
  //       </Grid>
  //       <Grid item sm={1.5}>
  //         <LabelValue label="Program ID">{job.title?.program_id || '-'}</LabelValue>
  //       </Grid>
  //       <Grid item sm={1.5}>
  //         <LabelValue label="Piece ID">{job.piece_id || '-'}</LabelValue>
  //       </Grid>
  //       <Grid item sm={1.5}>
  //         <LabelValue label="Piece Number">{job.piece_number || '-'}</LabelValue>
  //       </Grid>
  //     </Grid>
  //   );
  // }
};

export default orderPlacementConfig;
